<template>
	<div id="webSearth">
		<div class="banner">
			<el-image class="background" :src="banner" fit='cover'></el-image>
			<!-- <b class="mask"></b> -->
			<div class="main">
				<!-- <img class="ban" src="@/assets/imgs/banner.png" alt=""> -->
				<div class="cont">
					<!-- <p>查询优秀科普文章</p> -->
					<!-- <b>Search for excellent popular science articles</b> -->
					<el-input placeholder="请输入作品标题/作者..." v-model="searth" @change="searthChange" @clear="searthChange"
						clearable>
						<i slot="suffix" class="el-input__icon el-icon-search" @click="searthChange"
							style="cursor: pointer;"></i>
					</el-input>
				</div>
				<!-- <div class="cont2">
					<b>项目周期：2024年3月-2025年4月</b>
					<b>指导发起单位：中国初级卫生保健基金会</b>
					<b>执行单位：北京生命绿洲公益服务中心</b>
					<b>鸣谢支持：<img :src="require('@/assets/imgs/QL_logo2.png')" style="height: 36px;" alt=""></b>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getConfig, // 首页获取logo banner 流程图
		getProject
	} from '@/request/api.js';
	export default {
		name: 'webSearth',
		components: {},
		data() {
			return {
				mainColor: '',
				banner: '',
				searth: '',
			}
		},
		created() {
			this.mainColor = localStorage.getItem('mainColor');
			this.getProjectFun();
			this.getConfigFun();
		},
		mounted() {},
		methods: {
			// 首页项目介绍
			getProjectFun() {
				getProject().then(res => {
					if (res.code == 200) {
						// console.log()
						this.mainColor = res.data.mainColor;
					}
				})
			},

			searthChange() {
				let path = this.$route.path;
				if (path != '/contribute') {
					this.$router.push({
						path: '/contribute',
						query: {
							type: 'searth'
						}
					})
				}
				this.$emit('searthChange', {
					content: this.searth
				})
			},

			// 首页获取logo banner 流程图
			getConfigFun() {
				getConfig().then(res => {
					if (res.code == 200) {
						this.banner = res.data.bannerPath;
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	$main-color: v-bind(mainColor);

	#webSearth {
		.banner {
			height: 630px;
			position: relative;
			width: 1200px;
			margin: 20px auto 0;
			border-radius: 30px;
			overflow: hidden;

			.webHander {
				position: absolute;
				left: 0;
				top: 0;
				right: 0;
				z-index: 1;
			}

			.background {
				position: absolute;
				width: 100%;
				height: 100%;
				z-index: 0;
			}

			.mask {
				display: none;
				position: absolute;
				left: 0;
				top: 0;
				right: 0;
				bottom: 0;
				z-index: 0;
				background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(252, 253, 255, 1) 100%)
			}

			.main {
				width: 660px;
				height: 630px;
				z-index: 0;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: flex-start;
				position: relative;

				.ban {
					height: 100px;
					z-index: 100;
					margin-left: -30px;
					margin-top: 5px;
				}

				.cont2 {
					display: flex;
					flex-direction: column;
					margin-top: 20px;

					p {
						font-size: 70px;
						font-weight: 600;
						line-height: 1.5;
						color: #0082CE;
						// text-shadow: 0 0 5px #333;
					}

					b {
						font-size: 16px;
						font-weight: normal;
						margin-top: 12px;
						opacity: .8;
						line-height: 1.5;
						color: #666;
						// text-shadow: 0 0 5px #000;

						img {
							height: 36px;
						}
					}
				}

				.cont {
					z-index: 10;
					width: 500px;
					display: flex;
					flex-direction: column;
					position: absolute;
					left: 10%;
					bottom: 10%;

					p {
						// text-align: center;
						font-size: 36px;
						color: #0082CE;
						// text-shadow: 0 0 5px #333;
					}

					b {
						// text-align: center;
						font-size: 14px;
						color: #0082CE;
						// text-shadow: 0 0 5px #333;
						margin-bottom: 40px;
					}

					::v-deep .el-input {
						height: 60px;
						display: flex;
						flex-direction: row;
						align-items: center;
						box-shadow: 10px 10px 50px 0px rgba(103, 114, 148, 0.3);
						border: none;
						background-color: #fff;
						border-radius: 4px;
						position: relative;
						padding: 0 20px;

						.el-input__inner {
							height: auto;
							font-size: 24px;
							border: none;
							flex: 1;
							padding: 0;
							display: flex;
						}

						.el-input__suffix {

							.el-input__suffix-inner {
								font-size: 40px;
								height: 40px;
								width: 40px;
								line-height: 1;

								color: $main-color;
							}
						}

						.el-icon-search {
							display: block;
							width: 40px;
							height: 40px;
							position: absolute;
							right: -100%;
							top: 50%;
							transform: translateY(-50%);
						}

						.el-icon__clear {
							display: block;
						}
					}
				}
			}
		}
	}
</style>
